var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5395 6.50453C22.4207 6.01336 22.1788 5.56333 21.8381 5.1999C21.4975 4.83647 21.0703 4.57251 20.5996 4.43467C18.8796 4 12 4 12 4C12 4 5.12036 4 3.40045 4.47607C2.92972 4.6139 2.50247 4.87787 2.16186 5.2413C1.82124 5.60473 1.57933 6.05476 1.46055 6.54593C1.14578 8.35245 0.991808 10.1851 1.00057 12.0207C0.989351 13.8702 1.14333 15.7167 1.46055 17.5369C1.5915 18.0128 1.83883 18.4457 2.17865 18.7938C2.51847 19.1419 2.93929 19.3933 3.40045 19.5239C5.12036 20 12 20 12 20C12 20 18.8796 20 20.5996 19.5239C21.0703 19.3861 21.4975 19.1221 21.8381 18.7587C22.1788 18.3953 22.4207 17.9452 22.5395 17.4541C22.8518 15.6612 23.0058 13.8425 22.9994 12.0207C23.0106 10.1712 22.8567 8.32466 22.5395 6.50453Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.0205L15.5 11.7505L9.75 8.48047V15.0205Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f041794ce4944f30ab52172f8fe78ed8.svg";
export { ForwardRef as ReactComponent };